export const Header = () => {
  return(
    <div className="header">
      <header><strong>Pleasant Goat Memory Game!</strong></header>
      <div>** ( Don't pick the same character twice. ) **</div>
    </div>
  ) 
};
 